import React from 'react';
import { Button } from 'react-bootstrap';

const SaveCancelButtons = props => (
  <div className="profile-info-buttons ch-pass danger-success">
    <Button onClick={props.cancelChanges} bsStyle="danger" disabled={props.disabled}>
      Cancel
    </Button>
    <Button onClick={props.saveChanges} bsStyle="success" disabled={props.disabled}>
      Save changes
    </Button>
  </div>
);

export default SaveCancelButtons;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Profile/SaveCancelButtons.js